import React from 'react';
const BatteryIcon = () => (
    <svg width="18" height="32" viewBox="0 0 55 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="1.33951"
            y="1"
            width="52.321"
            height="98"
            rx="5"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="1"
            y="1"
            width="52.321"
            height="98"
            rx="5"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="16.7716"
            y="1"
            width="21.4568"
            height="5.40741"
            rx="1"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <rect x="17.0062" y="92.5926" width="20.9877" height="2.46914" rx="1.23457" fill="black" />
        <rect x="10" y="43" width="32.0129" height="14" rx="2" stroke="#32AE57" strokeWidth="2" />
        <rect x="41" y="47" width="3" height="6" rx="1" fill="#32AE57" />
        <rect x="12" y="45" width="28" height="10" rx="1" fill="#32AE57" />
    </svg>
);

export default BatteryIcon;



// WEBPACK FOOTER //
// ./src/components/icons/BatteryIcon.js